import React, { useEffect, useState } from "react";
import { CreditCardIcon, DangerRedIcon, DangerRoundRedIcon, DangerWhiteIcon, GrowthChartIcon, LocationGreenIcon, UsersBlackIcon, UsersBlueIcon, UsersGreyIcon, WallClockIcon } from "../../../assets/icons";
import Loader from "../../shared/Loader";
import { useNotification } from "../../toster-notification/NotificationContext";
import { AdminDashboardStatsDTO } from "../../../models/user/user.response";
import { userService } from "../../../services/userService";
import { useNavigate } from "react-router-dom";

const DashboardPage: React.FC = () => {

    const [dashboardInfo, setDashboardInfo] = useState<AdminDashboardStatsDTO>();

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();
    const navigate = useNavigate();


    useEffect(() => {
        fetchDashboardInfo();
    }, []);


    const fetchDashboardInfo = async () => {

        setLoading(true);
        try {
            const response = await userService.getSuperAdminDashboardInfo();

            if (response.data && response.success) {
                setDashboardInfo(response.data);
            } else {
                notify("error", "Nije moguće učitati podatke za dashboard.");
            }
        } catch (error) {
            notify("error", "Greška prilikom učitavanja podataka za dashboard.");
        } finally {
            setLoading(false);
        }
    }


    if (loading) {
        return <Loader />
    }

    return (
        <section className="sa-dashboard-section">
            <div className="w-layout-blockcontainer container w-container">
                <div className="sttings-content-wrapper">
                    <div className="header-div">
                        <div>
                            <h2 className="heading-3">Dashboard</h2>
                            <div className="text-block">Pregled sistema i ključne statistike</div>
                        </div>
                    </div>
                    <div className="sa-dashboard-stats-list">
                        <div className="admin-settings-box-div sa-dashboard-stats-div">
                            <div className="sa-dashboard-stats-header">
                                <div className="text-block-4">Ukupno vlasnika</div>
                                <div className="sa-dashboard-stats-image-div">
                                    <img loading="lazy" src={UsersBlueIcon} alt="" className="icon-size-24" />
                                </div>
                            </div>
                            <div className="sa-dashboard-stats-info-div">
                                <div className="sa-dashboard-stats-number">
                                    {dashboardInfo?.totalOwnersCount || 0} <span className="text-span-2">({dashboardInfo?.activeOwnersCount || 0} aktivnih) </span>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div sa-dashboard-stats-div">
                            <div className="sa-dashboard-stats-header">
                                <div className="text-block-4">Ukupno Lokala</div>
                                <div className="sa-dashboard-stats-image-div location">
                                    <img loading="lazy" src={LocationGreenIcon} alt="" className="icon-size-24" />
                                </div>
                            </div>
                            <div className="sa-dashboard-stats-info-div">
                                <div className="sa-dashboard-stats-number">
                                    {dashboardInfo?.totalLocalsCount || 0} <span className="text-span-2">({dashboardInfo?.activeLocalsCount || 0} aktivnih) </span>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div sa-dashboard-stats-div">
                            <div className="sa-dashboard-stats-header">
                                <div className="text-block-4">Aktivne Članarine</div>
                                <div className="sa-dashboard-stats-image-div cart">
                                    <img loading="lazy" src={CreditCardIcon} alt="" className="icon-size-24" />
                                </div>
                            </div>
                            <div className="sa-dashboard-stats-info-div">
                                <div className="sa-dashboard-stats-number">
                                    {dashboardInfo?.totalPlanSubscriptionCount || 0} <span className="text-span-2">({dashboardInfo?.expiredSoonPlanSubscriptionCount || 0} ističu uskoro) </span>
                                </div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div sa-dashboard-stats-div">
                            <div className="sa-dashboard-stats-header">
                                <div className="text-block-4">Prihod (Mesečni)</div>
                                <div className="sa-dashboard-stats-image-div grown">
                                    <img loading="lazy" src={GrowthChartIcon} alt="" className="icon-size-24" />
                                </div>
                            </div>
                            <div className="sa-dashboard-stats-info-div">
                                <div className="sa-dashboard-stats-number">
                                    {dashboardInfo?.monthIncome || 0} RSD <span className="text-span-2"></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sa-dashboard-footer">
                        <div className="admin-settings-box-div sa-dashboard-last-register-users">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Nedavno Registrovani Vlasnici</div>
                                    <div className="list-header-description">
                                        Najnoviji korisnici u sistemu<br />
                                    </div>
                                </div>
                            </div>
                            <div className="sa-dashboard-last-register-users-list">

                                {dashboardInfo?.owners.map(owner => (
                                    <div className="sa-dashboard-last-register-user-div" key={owner.id}>
                                        <div className="sa-dashboard-last-register-users-photo-div">
                                            <img loading="lazy" src={UsersBlackIcon} alt="" className="icon-size-20" />
                                        </div>
                                        <div className="sa-dashboard-last-register-user-info-div">
                                            <div className="sa-dashboard-last-register-user-name">{owner.fullName}</div>
                                            <div className="description-text">{owner.email}</div>
                                        </div>
                                        <div className="sa-dashboard-last-register-user-additional-info">
                                            {owner.isActive ? (
                                                <div className="small-box-div black-bg">
                                                    <div>Aktivan</div>
                                                </div>
                                            ) : (
                                                <div className="small-box-div grey-bg">
                                                    <div>Deaktivan</div>
                                                </div>
                                            )}
                                            <div className="description-text">{owner.localsCount || 0} lokacije</div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                        <div className="admin-settings-box-div sa-dashboard-plans-info-div">
                            <div className="sa-dashboard-plans-info-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Članarine koje Ističu</div>
                                    <div className="list-header-description">
                                        Pažnja potrebna u narednih 7 dana<br />
                                    </div>
                                </div>
                                <div className="div-block-9" onClick={() => navigate("/sa-settings/plans")}>
                                    <div>Vidi sve</div>
                                </div>
                            </div>
                            <div className="sa-dashboard-plan-ending-user-list">

                                {dashboardInfo?.plans.map(plan => (
                                    <div className={`sa-dashboard-plan-ending-user-div ${plan.planSubscriptionDaysLeft <= 5 ? "warning" : ""}`} key={plan.id}>
                                        <div className="sa-dashboard-plan-ending-user-image-div">
                                            <img loading="lazy" src={plan.planSubscriptionDaysLeft <= 5 ? DangerRedIcon : DangerRoundRedIcon} alt="" className="icon-size-24" />
                                        </div>
                                        <div className="sa-dashboard-plan-ending-user-info">
                                            <div className="sa-dashboard-plan-ending-user-local-name">{plan.localName}</div>
                                            <div className="description-text">{plan.ownerName}</div>
                                        </div>
                                        <div className={`small-box-div ${plan.planSubscriptionDaysLeft <= 5 ? "red-bg" : "grey-bg"}`}>
                                            <img loading="lazy" src={plan.planSubscriptionDaysLeft <= 5 ? DangerWhiteIcon : WallClockIcon} alt="" className="icon-size-20" />
                                            <div>{plan.planSubscriptionDaysLeft} dana</div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default DashboardPage;